export const Required = { text: 'Required', value: 1 };
export const CAP = { text: 'Corrective Action Plan', value: 3 };

export const actionTypes = [
    {"text": Required.text, "value": Required.value},
    {"text": CAP.text, "value": CAP.value}
];